import { Component, OnInit, Input } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';

import { FieldConfig } from '../../models/field-configs/field-config.interface';
import { AbstractField } from '../../models/field-configs/abstract-field';
import { getObservableFromAsyncValueSafe } from '@ordersnproducts/modules/shared/models/async-value';
import { takeUntil } from 'rxjs/operators';
import { BehaviorSubject, Subject } from 'rxjs';

@Component({
  selector: 'form-textarea',
  styleUrls: ['form-textarea.component.scss'],
  templateUrl: 'form-textarea.component.html',
})
export class FormTextAreaComponent extends AbstractField implements OnInit {
  config: FieldConfig;
  group: UntypedFormGroup;
  fieldControl: UntypedFormControl;
  @Input()
  rtl = false;
  public controlStatusMessage$ = new BehaviorSubject('');
  isRequired = false;
  visible = true;
  blockedKeys: string[] = [];
  private _ngDestroyed = new Subject();

  ngOnInit(): void {
    this.fieldControl = this.getControl() as UntypedFormControl;
    this.isRequired = this.hasRequiredField(this.fieldControl);
    if (this.config.visible !== undefined) {
      getObservableFromAsyncValueSafe(this.config.visible)
        .pipe(takeUntil(this._ngDestroyed))
        .subscribe((fieldVisibility) => (this.visible = fieldVisibility));
    }

    if (this.config.value) {
      getObservableFromAsyncValueSafe(this.config.value)
        .pipe(takeUntil(this._ngDestroyed))
        .subscribe((value) => {
          this.getControl().setValue(value);
        });
    }
    this.fieldControl.statusChanges.subscribe(() => {
      if (this.fieldControl.invalid && this.fieldControl.hasError('required')) {
        this.controlStatusMessage$.next('forms.required');
      } else if (this.fieldControl.valid) {
        this.controlStatusMessage$.next('');
      }
    });

    if (!!this.config.blockedKeys) {
      this.blockedKeys = this.config.blockedKeys;
    }
  }
}
